import { render, staticRenderFns } from "./VascularExam.vue?vue&type=template&id=4903f088&"
import script from "./VascularExam.vue?vue&type=script&lang=js&"
export * from "./VascularExam.vue?vue&type=script&lang=js&"
import style0 from "./VascularExam.vue?vue&type=style&index=0&id=4903f088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports